const WishlistReducerActions = {
  LOAD_WISHLIST: 'load',
  ADD_OFFER: 'add',
  REMOVE_OFFER: 'remove'
};

const WishlistReducer = ({ wishlist }, { type, payload }) => {
  switch (type) {
    case WishlistReducerActions.LOAD_WISHLIST:
      return { wishlist: payload, isToMakeApiRequest: false };
    case WishlistReducerActions.ADD_OFFER:
      return addOffer(wishlist, payload);
    case WishlistReducerActions.REMOVE_OFFER:
      return removeOffer(wishlist, payload);
    default:
      throw Error(`unrecognized action "${type}"`);
  }
};

const cityWishlist = (wishlist, city) => wishlist[city] || [];

const addOffer = (wishlist, { offerId, city, isToMakeApiRequest = true }) => ({
  wishlist: { ...wishlist, [city]: [...cityWishlist(wishlist, city), parseInt(offerId, 10)] },
  isToMakeApiRequest
});

const removeOffer = (wishlist, { offerId, city, isToMakeApiRequest = true }) => ({
  wishlist: { ...wishlist, [city]: cityWishlist(wishlist, city).filter(id => id !== parseInt(offerId, 10)) },
  isToMakeApiRequest
});

export { WishlistReducer, WishlistReducerActions };
